import { useState } from "react";
import { categoryGroups } from "@/mocks/archive";

export default function CategoryZones() {
  const [active, setActive] = useState(categoryGroups[0].key);
  const zone = categoryGroups.find((z) => z.key === active) ?? categoryGroups[0];

  return (
    <section id="zones" className="bg-background-100 border-t border-background-200">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10">
          {/* 左：分区说明 + tab */}
          <div className="lg:col-span-5">
            <p className="flex items-center gap-2 text-sm font-medium text-accent-700">
              <i className="ri-folders-line" />
              分类考古
            </p>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              旧料按型归档
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              被扒、翻旧账、早年黑历史与历史遗留是四种不同的考据路径，归档方式与可信度判断也各不相同。
            </p>

            {/* 分段控制 */}
            <div className="mt-6 flex flex-wrap gap-2">
              {categoryGroups.map((z) => {
                const isActive = z.key === active;
                return (
                  <button
                    key={z.key}
                    type="button"
                    onClick={() => setActive(z.key)}
                    className={
                      "inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-medium whitespace-nowrap transition-colors " +
                      (isActive
                        ? "bg-accent-500 text-background-50"
                        : "bg-background-50 text-foreground-700 hover:bg-background-200 border border-background-200")
                    }
                  >
                    <i className={isActive ? "ri-focus-2-line" : "ri-focus-2-line"} />
                    {z.name}
                  </button>
                );
              })}
            </div>

            <div className="mt-6 rounded-lg border border-background-200 bg-background-50 p-5">
              <div className="flex items-center justify-between">
                <h3 className="font-heading text-lg font-bold text-foreground-900">{zone.name}</h3>
                <span className="rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-900 whitespace-nowrap">
                  {zone.items.length} 条精选
                </span>
              </div>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{zone.desc}</p>
              <p className="mt-3 text-xs text-foreground-400">
                点击下方条目查看该分区旧料的完整考据归档。
              </p>
            </div>
          </div>

          {/* 右：条目列表（标题 + 短摘要） */}
          <div className="lg:col-span-7">
            <div className="flex flex-col gap-4">
              {zone.items.map((item, i) => (
                <a
                  key={item.id}
                  href="#deep"
                  className="group rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 hover:border-primary-300 transition-colors"
                >
                  <div className="flex items-start gap-4">
                    <span className="hidden sm:flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-background-100 text-lg font-bold text-primary-600 font-heading">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <div className="min-w-0">
                      <div className="flex flex-wrap items-center gap-2 text-xs">
                        <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 font-medium text-secondary-900 whitespace-nowrap">
                          {item.kind}
                        </span>
                        <span className="text-foreground-400">始于 {item.year}</span>
                        <span className="text-foreground-400 hidden sm:inline">·</span>
                        <span className="text-foreground-400 hidden sm:inline">{item.meta}</span>
                      </div>
                      <h3 className="mt-2 font-heading text-lg font-bold leading-snug text-foreground-900 group-hover:text-primary-700 transition-colors">
                        {item.title}
                      </h3>
                      <p className="mt-2 text-sm leading-relaxed text-foreground-600 line-clamp-2">
                        {item.summary}
                      </p>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}